"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var context_1 = tslib_1.__importDefault(require("@eduzz/houston-forms/deprecated/context"));
var Form = function (_a) {
    var context = _a.context, rest = tslib_1.__rest(_a, ["context"]);
    return ((0, jsx_runtime_1.jsx)(context_1.default.Provider, tslib_1.__assign({ value: context }, { children: (0, jsx_runtime_1.jsx)("form", tslib_1.__assign({}, rest, { onReset: context.handleReset, onSubmit: context.handleSubmit })) })));
};
/**
 * @deprecated
 */
exports.default = React.memo(Form);
